import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { PageLayout } from '../enums/page-layout';
import { PageLayoutService } from '../services/page-layout/page-layout.service';

export const setLayoutResolver = (inputLayout: PageLayout): ResolveFn<void> => {
  return () => {
    inject(PageLayoutService).setLayout(inputLayout);
  };
};
